import { UserGroupIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";

export const EmployeesFeature: FeatureMetadata = {
  id: "employees",
  moduleName: "humanResources",

  navigation: {
    label: "Employees",
    path: "/employees",
    icon: UserGroupIcon,
    order: 0.5,
  },

  route: {
    path: "/employees/*",
    element: lazy(() => import("./pages/Employees")),
  },

  permissions: {
    view: "HumanResource.Employees.view",
    create: "HumanResource.Employees.create",
    edit: "HumanResource.Employees.edit",
    delete: "HumanResource.Employees.delete",
  },

  readiness: "live",
};
